export default __webpack_public_path__ + "static/media/ast-auto3.9dce7835.png";